<template>
    <v-label class="text-left d-block">
      {{ modelValue.title }}
      <span v-if="modelValue.mandatory" class="text-error">*</span>
    </v-label>

    <v-table>
        <thead>
            <tr>
                <th class="text-left font-weight-bold"></th>
                <th v-for="(columnName, columnIndex) in modelValue.columns" :key="columnIndex"
                    class="text-center font-weight-bold">
                    {{ columnName }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(rowName, rowIndex) in modelValue.rows" :key="rowIndex">
                <td class="text-left font-weight-medium">
                    {{ rowName }}
                </td>
                <td v-for="(columnName, columnIndex) in modelValue.columns" :key="`${rowIndex}-${columnIndex}`">
                    <v-radio-group 
                        :model-value="getRadioValue(rowIndex, columnIndex)"
                        @update:model-value="handleChange($event, rowIndex, columnIndex)" 
                        hide-details
                        class="ma-0 pa-0 d-flex justify-center"
                        >
                        <v-radio :value="true" density="compact" class="ma-0" />
                    </v-radio-group>
                </td>
            </tr>
        </tbody>
    </v-table>
</template>

<script>
import { dumpMatrix } from '../../utils/matrix.js';

export default {
    name: 'MultipleChoiceGridComponent',

    props: ['modelValue',], //modelValue - it the name of the prop that will be used for v-model binding (from parent component)
    emits: ['update:modelValue'],

    methods: {
        getRadioValue(rowIndex, columnIndex) {
            if (!this.modelValue.value || !this.modelValue.value[rowIndex]) {
                return false;
            }
            return this.modelValue.value[rowIndex][columnIndex];
        },

        handleChange(value, rowIndex, columnIndex) {
            console.log("Current model", this.modelValue);
            console.log(`Row index ${rowIndex}, Column index: ${columnIndex}`)
            // console.log("Radio checked = ", value);

            let newModelValue = {
                ...this.modelValue,
                error: '', // Reset any previous error
            };

            // Check if 'value' key is set at the modelValue level
            if (!('value' in this.modelValue)) { // Default values                
                let matrix = [];
                for (var i = 0; i < this.modelValue.row.length; i++) {
                    matrix[i] = [];
                    for (var j = 0; j < this.modelValue.columns.length; j++) {
                        matrix[i][j] = 0;
                    }
                }
                newModelValue['value'] = matrix;
            }

            // Reset whole line
            for (var jj = 0; jj < this.modelValue.columns.length; jj++) {
                newModelValue.value[rowIndex][jj] = false;
            }

            // Set correct value
            if(value){
                newModelValue.value[rowIndex][columnIndex] = true;
                console.log("New model", newModelValue);
                console.log(dumpMatrix(newModelValue.value));
            }

            // Trigger new model
            this.$emit('update:modelValue', newModelValue);
        },
    }

}
</script>

<style scoped></style>